import React from 'react';
import '../App.css'
import { AiOutlineClose } from 'react-icons/ai';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
import { userService } from '../services/UserService';
import { deleteLocalStorage, authHeader, gettokens, getDidTokens } from "../helpers/auth-header";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { InformationCircleIcon, ClipboardDocumentIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline'
import { Fragment, useState } from 'react'
import SideMenu from './SideMenu';
import StoryVideoGeneration from './StoryVideoGeneration';
import Autocomplete from 'react-google-autocomplete';
import { useHistory } from 'react-router-dom';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';
import {
	Bars3Icon,
	XMarkIcon
} from '@heroicons/react/24/outline'
import { homeDataConstants } from '../constants/HomeDataConstants';

var url = process.env.REACT_APP_URL || "http://localhost:8080/";

const firebaseConfig = {
	apiKey: "AIzaSyCT-HKuQUQT94cSIF5Fu7zzPnWbn9ao8i0",
	authDomain: "hopguides.firebaseapp.com",
	projectId: "hopguides",
	storageBucket: "hopguides.appspot.com",
	messagingSenderId: "520191148823",
	appId: "1:520191148823:web:f1920e502d3f692840ad52"
};

firebase.initializeApp(firebaseConfig);
function classNames(...classes) {
	return classes.filter(Boolean).join(' ')
}



const audienceNames = {
	1: "History Buffs",
	2: "School Students",
	3: "Art Enthusiasts",
	4: "Adventure Seekers",
	5: "Foodies",
	6: "Photographers",
	7: "Literature Lovers",
	8: "Tech Aficionados",
	9: "Nature Wanderers",
	10: "Night Owls",
	11: "Music Admirers",
	12: "Architectural Admirers",
	13: "Family Trippers",
	14: "Football lovers",
	15: "Solo Explorers",
	16: "Retirees",
};
function LoadingOverlay() {
	return (
		<div className="loading-overlay flex flex-col items-center justify-center">
			<div className="loading-spinner"></div>
			<div className="loading-text">This may take up to five minutes</div>
		</div>
	);
}

const usePrompt = (when, message) => {
	const history = useHistory();

	console.log(history)
	React.useEffect(() => {
		const handleBeforeUnload = (e) => {
			if (!when) return;
			e.preventDefault();
			return (e.returnValue = message);
		};

		const unblock = history.block((location, action) => {
			if (when && window.confirm(message)) {
				unblock();
				return true;
			}
			return false;
		});

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			unblock();
		};
	}, [when, message, history]);
};


function StoryCreation() {
	// Moved state to this parent component


	const [copied, setCopied] = useState(false);

	const [ready, setReady] = React.useState(false);
	const [address, setAddress] = useState("");
	const [copiedId, setCopiedId] = useState(null);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [countTokens, setCountTokens] = React.useState(false);
	const [tokens, setTokens] = React.useState("");
	const [selectedImage, setSelectedImage] = React.useState('imgSam');
	const [updateapi, setUpdateapi] = React.useState(false);
	const [api, setApi] = React.useState("");
	const [videos, setVideos] = React.useState([]);
	const [sidebarOpen, setSidebarOpen] = useState(false)
	const [selectedItem, setSelectedItem] = useState("");
	const [place, setPlace] = useState("");
	const [isLoaded, setIsLoaded] = React.useState(false); // New state to track loading
	const [admin, setAdmin] = React.useState(false);
	const [fewTokens, setFewTokens] = React.useState(false);
	const handleItemSelect = (item) => {
		setSelectedItem(item);
	};
	const [isOpen, setIsOpen] = useState(false)
	const { homeDataState, dispatch } = React.useContext(HomeDataContext);
	const handleChange = address => {
		setAddress(address);
	};

	const handleSelect = address => {
		console.log(address)
		setPlace(address)

	};

	const handleClick = (index) => {
		console.log(address)
		console.log(index)
		if (homeDataState.editIndex === index) {
			// Check if a new place has been selected
			if (address) {
				// Update the location with the new place
				dispatch({
					type: homeDataConstants.UPDATE_LOCATION,
					payload: { index, value: address },
				});
				setAddress(null); // Reset the selected place
			} else {
				// No new place was selected, keep the old value
				dispatch({
					type: homeDataConstants.UPDATE_LOCATION,
					payload: { index, value: homeDataState.locations[index] },
				});
			}
		} else {
			// Prepare to edit a new location
			setAddress(null); // Reset the selected place
			dispatch({ type: homeDataConstants.TOGGLE_EDIT, payload: index });
		}
	};
	const [story, setStory] = React.useState(homeDataState?.story || "");
	React.useEffect(() => {
		// Using an async function inside useEffect
		const fetchData = async () => {
			var tokens = await userService.getTokens(dispatch);
			var videos = await homeDataService.getVideosForLibrary(dispatch);
			var token = authHeader();

			if (token == "null" || tokens == "undefined" || tokens == "null") {
				window.location = "#/login";
			} else {

				if (tokens < 500) {
					setFewTokens(true)
				}
				setIsLoaded(true); // Set isLoaded to true only if tokens are valid
			}
		};

		fetchData(); // Call the async function

	}, []); // Empty dependency array to run the effect only once on component mount



	const handleLogout = () => {
		deleteLocalStorage();
		firebase.auth().signOut().then(function () {
			// Sign-out successful.
		}).catch(function (error) {
			// An error happened.
		});
		window.location = "#/login";
	};
	const [selectedCity, setSelectedCity] = useState('');
	const [selectedAudience, setSelectedAudience] = useState('');
	const [isDataDirty, setIsDataDirty] = useState(true);

	const handleInputChange = (event) => {
		setSelectedCity(event.target.value);
	};

	const handleAudienceSelect = (audience) => {
		setSelectedAudience(audience);
	};


	const searchFamousPeople = async () => {

		setErrorMessage("")
		if (selectedCity == "" || selectedAudience == "") {
			setErrorMessage("Please select city and  audience")
		} else {
			var data = {
				city: selectedCity,
				audience: selectedAudience,

			}

			await homeDataService.getFamousPeople(dispatch, data);
		}

	};
	usePrompt(isDataDirty, "Are you sure you want to leave this page? All data will be deleted.");


	const generateText = async () => {

		setErrorMessage("")
		if (selectedCity == "" || selectedAudience == "" || selectedItem == "") {
			setErrorMessage("Please select city, audience and famous person ")
		} else {

			var story = []
			console.log(homeDataState.part)
			dispatch({
				type: homeDataConstants.LOADING_START
			});
			let localConversationHistory = homeDataState.conversation_history; // Local variable
			console.log(localConversationHistory);
			setReady(false)
			for (let i = 0; i < 10; i++) {
				var data = {
					city: selectedCity,
					audience: selectedAudience,
					famous_person: selectedItem,
					pois: homeDataState.locations,
					part: i + 1,
					conversation_history: localConversationHistory,
				};

				var tourName = `Experience in ${selectedCity}`;
				const generatedText = await homeDataService.getStory(dispatch, data, tourName);

				localConversationHistory = generatedText.conversation_history; // Update local variable
				console.log(generatedText);
				story.push(generatedText.story)

			}
			console.log(story)
			var tourName = `Experience in ${selectedCity}`;
			await homeDataService.createTour(dispatch,story, tourName);
			console.log("lalalallalalaaaaaaaaaaaa")
			setReady(true)
				dispatch({
					type: homeDataConstants.LOADING_END,
					payload: { dispatch: dispatch, tourName: tourName }
				});
			}


		};


		const generatepois = async () => {
			setErrorMessage("")
			if (selectedCity == "" || selectedAudience == "" || selectedItem == "") {
				setErrorMessage("Please select city, audience and famous person")
			} else {

				var data = {
					city: selectedCity,
					audience: selectedAudience,
					famous_person: selectedItem
				};

				// Await the result of the getStory function
				const generatedText = await homeDataService.generatepois(dispatch, data);
			}


		};

		const handleDragStart = (index) => {
			dispatch({ type: homeDataConstants.START_DRAG, payload: index });
		};

		const handleDragOver = (e) => {
			e.preventDefault(); // Necessary for the onDrop event to fire
		};

		const handleDrop = (index) => {
			if (homeDataState.draggedIndex !== null) {
				dispatch({ type: homeDataConstants.END_DRAG, payload: { draggedIndex: homeDataState.draggedIndex, overIndex: index } });
			}
		};

		const toggleMenu = () => {
			setIsOpen(!isOpen);
		};

		const handleClose = () => {

			setUpdateapi(false)
		};
		const handleSend = async () => {



			await homeDataService.updateApi(dispatch, api);

		};

		// Set this to true when changes are made to the page


		return (

			<div>
				{fewTokens && (
					<div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
						<div className="modal-overlay"></div>
						<div className="fixed inset-0">
							<div className="modal-frame">
								<div id="errorModal" className="modal modal--lg">
									<div className="modal__header flex justify-between items-center "> {/* Reduced padding */}
										<div><InformationCircleIcon className="h-9 w-9 text-red-600" aria-hidden="true" /></div> {/* Slightly reduced icon size */}

									</div>

									<div className="modal__body flex flex-col items-center justify-center p-5">
										<p className="text-center text-lg scaled-side-menu font-bold mb-4">
											Subscription Required
										</p>
										<div className="text-center scaled-side-menu text-md mb-4">
											To edit this description, you need to have an active subscription or more tokens. Please subscribe to unlock editing capabilities.
										</div>
										<div className="flex space-x-4 mb-4">
											<a href="https://hopguides-video-creation.netlify.app/#/subscription/5" className="button button-dimensions button--primary min-w-[8rem]">
												Subscribe Now
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}

				{homeDataState.loadingStory && <LoadingOverlay />}
				
				{ <div className="min-h-screen flex felx-row items-start md:items-stretch md:overflow-hidden divide-x-0 md:divide-x relative">
					{/* New */}
					<div className="min-h-screen flex felx-row items-start md:items-stretch md:overflow-hidden divide-x-0 md:divide-x relative">

						{/* Modal Change API */}

						{homeDataState.loading && <LoadingOverlay />}

						{updateapi &&

							<div className="fixed z-50 inset-0" aria-labelledby="modal-title" role="dialog" aria-modal="true">

								{/* Modal Overlay */}
								<div className="modal-overlay"></div>

								{/* Modal */}
								<div className="modal-frame">

									{/* Modal Content */}
									<div id="myModal" className="modal modal--lg">

										<div className="modal__header">
											<h2 className="text-leading scaled-title-menu text-black font-bold">
												Change api
											</h2>
											<button className="button button--circle button--clear justify-self-end" type="button" onClick={handleClose}>
												<AiOutlineClose />
											</button>
										</div>

										<div className="modal__body flex flex-col items-center justify-center p-5">
											<textarea rows="4" name="comment" onChange={e => setApi(e.target.value)} value={api} id="comment" className="form__input resize-none" />
										</div>

										<div className="modal__body flex flex-col items-center justify-center p-5 !pt-0">

											<div className="flex space-x-2">
												<button onClick={e => handleClose(e)} className="button button-dimensions button--secondary min-w-[8rem]">
													Cancel
												</button>
												<div><button onClick={e => handleSend(e)} className="button button-dimensions button--primary min-w-[8rem]">
													OK
												</button></div>
											</div>
										</div>

									</div>
								</div>
							</div>

						}




						{/* Left */}
						<div className="hidden lg:flex">
							<SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} admin={admin} setUpdateapi={setUpdateapi} handleLogout={handleLogout} storycreation={true} />
						</div>

						<div className="min-h-screen flex flex-col gap-0 items-stretch w-full overflow-hidden lg:divide-y-0">

							{/* Mobile Nav */}
							<div className="flex flex-row items-center justify-between px-5 h-16 lg:hidden fixed z-40 left-0 top-0 right-0 bg-white border-b border-black/10">
								<div>
									<img className="h-8 w-auto" src="assets/img/logo.svg" alt="Your Company" />
								</div>
								<div>
									<button onClick={toggleMenu} className='w-6'>  <Bars3Icon /> </button>
								</div>
							</div>
							{isOpen && (

								<div className="fixed inset-0 z-50 bg-neutral-100/70 backdrop-blur lg:hidden">
									<div className="fixed top-3 right-3 z-50 bg-white rounded-2xl shadow">
										<div className="px-5 pt-5 pb-0 flex flex-row items-center justify-end">
											<button onClick={toggleMenu} className='w-6'><XMarkIcon /></button>
										</div>
										<div>
											<SideMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} admin={admin} setUpdateapi={setUpdateapi} handleLogout={handleLogout} storycreation={true} />
										</div>
									</div>
								</div>
							)}
							{/* Right */}
							<div className="grow flex flex-col md:flex-row items-stretch w-full md:overflow-hidden divide-x-0 md:divide-x divide-y md:divide-y-0">

								{/* Here */}
								{/* Center */}
								<div className="w-full">
									<div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-6">
										<div className="bg-neutral-100 bg-opacity-90 backdrop-blur rounded-lg">
											<div className="mx-auto px-2 py-16 sm:px-6 sm:py-4 lg:px-8">
												<div>
													<h1 className="text-3xl font-bold mb-4 text-black">Create experience </h1>

													<div htmlFor="useCases" className="sticky z-10  top-0 p-5 bg-opacity-90 backdrop-blur">
														<div className="section-title">
															<div className="label-count">1</div> Enter the city you want the experience to be about:
														</div>
													</div>

													<div className="mb-4">
														<PlacesAutocomplete
															value={selectedCity}
															onChange={(address) => {
																setAddress(address);
																handleInputChange({ target: { value: address } });
															}}
															searchOptions={{
																types: ['(cities)'], // Restrict search to cities, towns, and villages
															}}
														>
															{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
																<div className="relative flex flex-col flex-grow">
																	<input
																		{...getInputProps({
																			placeholder: 'Search Cities ...',
																			className: 'mt-1 p-2 border w-full p-3 ml-2 mr-4 border-gray-300 rounded-md',
																		})}
																	/>
																	<div className="absolute z-10 w-full bg-white shadow-lg max-h-60 mt-1 overflow-auto">
																		{loading && <div className="p-4 text-center">Loading...</div>}
																		{suggestions.map(suggestion => (
																			<div
																				{...getSuggestionItemProps(suggestion)}
																				key={suggestion.placeId}
																				className={`p-4 border-b border-gray-100 cursor-pointer ${suggestion.active ? 'bg-gray-100' : 'bg-white'}`}
																			>
																				{suggestion.description}
																			</div>
																		))}
																	</div>
																</div>
															)}
														</PlacesAutocomplete>
													</div>
													<div htmlFor="useCases" className=" z-10  top-0 p-5 bg-opacity-90 backdrop-blur">
														<div className="section-title">
															<div className="label-count">2</div> Please pick one of the audience options:
														</div>
													</div>
													<div className="mb-6">

														<div className="flex flex-wrap gap-2">
															{Object.entries(audienceNames).map(([key, value]) => (
																<button
																	key={key}
																	className={`py-2 px-4 rounded-md text-sm ${selectedAudience === value ? 'bg-gray-400 text-white' : 'bg-white text-gray-800'}`}
																	onClick={() => handleAudienceSelect(value)}
																>
																	{value}
																</button>
															))}
														</div>
													</div>

													<div style={{ textAlign: "center" }} className='mt-6'>
														<p className="text-sm font-medium text-gray-700 mt-6">Selected City: {selectedCity}</p>
														<p className="text-sm font-medium text-gray-700">Selected Audience: {selectedAudience}</p>
													</div>
													<div className="mb-4 mt-8 flex justify-center">
														{/* Button in the middle */}
														<button className="button button-dimensions button--primary min-w-[10rem]" onClick={searchFamousPeople}>
															Suggest the narrator
														</button>
													</div>
													<div className="mb-4">
														{/* List of items */}
														{homeDataState.famouspeople.length != 0 &&


															<div htmlFor="useCases" className="sticky z-10  top-0 p-5 bg-opacity-90 backdrop-blur">
																<div className="section-title">
																	<div className="label-count">3</div> Select a person:
																</div>
															</div>}
														<div className="grid grid-cols-2 gap-4">
															{homeDataState.famouspeople.map((item) => (
																<div
																	key={item}
																	className={`border p-4 rounded-md  bg-white cursor-pointer ${selectedItem === item ? 'border-gray-500 border-2 bg-gray-100' : 'border-gray-300 hover:border-gray-500'
																		}`}
																	onClick={() => handleItemSelect(item)}
																>
																	<p className={`text-sm font-medium ${selectedItem === item ? 'text-gray-800' : 'text-gray-600'}`}>
																		{item}
																	</p>
																</div>
															))}
														</div>
													</div>
													<div className="mb-4 mt-8 flex justify-center">
														{/* Button in the middle */}
														{homeDataState.famouspeople.length != 0 && <button className="button button-dimensions button--primary min-w-[10rem]" onClick={generatepois}>
															Find relevant points of interest
														</button>}
													</div>


													{homeDataState.locations.length != 0 && <div><div htmlFor="useCases" className=" z-10 top-0 p-5">
														<div className="section-title">
															<div className="label-count">4</div> These are the recommended points of interest (POI) for this experience. Rearrange the sequence of points of interest so that visitors can explore them in a convenient circular route.
														</div>
													</div>

														{/* Cities List */}


														<ul className="space-y-2 p-5">
															{homeDataState.locations.map((item, index) => (

																<li
																	key={index}
																	className="bg-white p-4 shadow rounded-lg flex justify-between items-center"
																	draggable
																	onDragStart={() => handleDragStart(index)}
																	onDragOver={handleDragOver}
																	onDrop={() => handleDrop(index)}
																>
																	<div className="cursor-grab mr-4" aria-hidden="true">≡</div>

																	<div className="cursor-grab mr-4 bold" aria-hidden="true">{index + 1}.</div>
																	{homeDataState.editIndex === index ? (
																		<PlacesAutocomplete
																			value={address}
																			onChange={setAddress}
																		>
																			{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
																				<div className="relative flex flex-col flex-grow">
																					<input
																						{...getInputProps({
																							placeholder: 'Search Places ...',
																							className: 'w-full p-4 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500',
																						})}
																					/>
																					<div className="absolute z-10 w-full bg-white shadow-lg max-h-60 mt-1 overflow-auto">
																						{loading && <div className="p-4 text-center">Loading...</div>}
																						{suggestions.map(suggestion => (
																							<div
																								{...getSuggestionItemProps(suggestion)}
																								key={suggestion.placeId}
																								className={`p-4 border-b border-gray-100 cursor-pointer ${suggestion.active ? 'bg-gray-100' : 'bg-white'}`}
																							>
																								{suggestion.description}
																							</div>
																						))}
																					</div>
																				</div>
																			)}
																		</PlacesAutocomplete>
																	) : (
																		<span className="flex-grow">{item}</span>
																	)}
																	<button className="border p-2 rounded-lg" onClick={() => handleClick(index)}>
																		{homeDataState.editIndex === index ? 'Done' : 'Edit'}
																	</button>
																</li>
															))}
														</ul>

														<div className="mb-4 mt-4 flex justify-center">
															{/* Button in the middle */}
															{homeDataState.famouspeople.length != 0 && <button className="button button-dimensions button--primary min-w-[10rem]" onClick={generateText}>
																Create experience
															</button>}
														</div>
													</div>}
													{errorMessage && (
														<div className="flex flex-col items-center text-sm text-red-500 m">
															{errorMessage}
														</div>
													)}
													{homeDataState.locations.length == 0 && <div> <div className="flex justify-center items-center h-screen">
														<div className="p-5">
															<div className="section-title !text-gray-300">
																There are no suggestions yet.
															</div>
														</div>
													</div>
													</div>}

												</div>
											</div>
										</div>
									</div>
								</div>
								{/* Right */}

							</div>
						</div>



					</div>

				</div >



				}

{homeDataState.ready && <div>< StoryVideoGeneration story={homeDataState.story} ready={ready}/></div>}
			</div>
		);
	}

	export default StoryCreation;